import { useField } from "formik";
import { Switch, Alert } from "@material-tailwind/react";

export default function FormikSwitch({ ...props }) {
    const [field, meta, helpers] = useField({ ...props, type: "checkbox" });

    return (
        <>
            <Switch
                checked={!!field.value}
                onChange={() => helpers.setValue(!field.value)}
                onBlur={field.onBlur}
                name={field.name}
                {...props}
            />
            {!!(meta.touched && meta.error) && (
                <Alert color="red" className="mt-1 rounded-lg py-1 pl-5">
                    {meta.error}
                </Alert>
            )}
        </>
    );
}
